import { isDesktop } from "@/js/helpers/mediaQueryHelper";

const SPACE_BETWEEN = 57;
const SPACE_BETWEEN_MOBILE = 25;

const HEADER_SELECTOR = ".js-header";
const TAKEOVER_DESKTOP_SELECTOR = ".js-takeover--desktop";
const TAKEOVER_MAIN_SELECTOR = ".js-takeover__main";
const MAIN_CONTENTS_SELECTOR = ".js-main__contents";
const PAGE_CONTENTS_SELECTOR = ".js-page-contents";
const SIDEBAR_SELECTOR = ".js-sidebar";
const FEATURED_IMAGE_SELECTOR = ".js-company__featured-image--fixed-top";

class CompanyFeaturedImageFixedTop {
    static getSpaceBetween() {
        return isDesktop() ? SPACE_BETWEEN : SPACE_BETWEEN_MOBILE;
    }

    constructor() {
        this.featuredImageElement = document.querySelector(FEATURED_IMAGE_SELECTOR);

        this.headerElement = document.querySelector(HEADER_SELECTOR);
        this.mainContentsElement = document.querySelector(MAIN_CONTENTS_SELECTOR);
        this.pageContentsElement = document.querySelector(PAGE_CONTENTS_SELECTOR);
        this.sidebarElement = document.querySelector(SIDEBAR_SELECTOR);

        this.takeoverDesktopElement = document.querySelector(TAKEOVER_DESKTOP_SELECTOR);
        if (this.takeoverDesktopElement) {
            this.takeoverDesktopMainElement =
                this.takeoverDesktopElement.querySelector(TAKEOVER_MAIN_SELECTOR);
        }

        if (this.featuredImageElement) {
            this.attach();
            this.adjustLayout();
        }
    }

    attach() {
        const adjustAllLayout = () => {
            this.adjustLayout();
            if (this.takeoverDesktopElement) {
                this.adjustLayoutWithTakeoverDesktop();
            }
        };

        this.featuredImageElement.querySelector("img").addEventListener("load", () => {
            adjustAllLayout();
        });

        window.addEventListener("resize", () => {
            adjustAllLayout();
        });

        if (this.takeoverDesktopElement) {
            this.takeoverDesktopElement.addEventListener("takeover:reposition", () => {
                this.adjustLayoutWithTakeoverDesktop();
            });
        }
    }

    moveFeaturedImageAfterHeader() {
        this.headerElement.insertAdjacentElement("afterend", this.featuredImageElement);
    }

    adjustLayout() {
        const spaceBetween = CompanyFeaturedImageFixedTop.getSpaceBetween();
        this.moveFeaturedImageAfterHeader();

        this.featuredImageElement.style.marginTop = 0;
        this.featuredImageElement.style.marginLeft = 0;

        this.pageContentsElement.style.paddingTop = `${spaceBetween}px`;
        if (this.sidebarElement) {
            this.sidebarElement.style.paddingTop = isDesktop() ? `${spaceBetween}px` : 0;
        }
    }

    adjustLayoutWithTakeoverDesktop() {
        const { "margin-top": mainContentsMarginTop } = this.mainContentsElement.style;
        const { offsetLeft } = this.takeoverDesktopMainElement;

        this.featuredImageElement.style.marginTop = mainContentsMarginTop;
        this.featuredImageElement.style.marginLeft = `${offsetLeft}px`;
        this.mainContentsElement.style.marginTop = 0;
        this.featuredImageElement.style.top = `${this.takeoverDesktopMainElement.clientHeight}px`;
    }
}

export { CompanyFeaturedImageFixedTop };
